import { useRef, forwardRef, Dispatch, SetStateAction, useEffect } from 'react'

/* Utils */
import { DataStatus, Label, VisibleLabel } from 'models'
import { CUSTOM_LABEL_ID } from '../../../library/utils'

/* Components */
import TrendsLabelCard from './components/TrendsLabelCard'
import { useLibraryDetails } from 'contexts/LibraryDetailsContext'

interface Props {
  handlePin: (labelId: string) => void
  handleEdit: (label: Label) => void
  visibleLabels: VisibleLabel[]
  width: number
  height: number
  margin: {
    top: number
    right: number
    bottom: number
    left: number
  }
  chartStatus?: DataStatus
  setWidth: Dispatch<SetStateAction<number>>
}

const TrendsChart = forwardRef<any, Props>(
  ({ setWidth, handlePin, handleEdit, visibleLabels, chartStatus, width, height, margin }, ref) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const { containerRef, svgRef } = ref
    const { renderingChart } = useLibraryDetails()
    const tooltipRef = useRef<HTMLDivElement | null>(null)
    const labelCardRef = useRef<HTMLDivElement | null>(null)

    useEffect(() => {
      if (!containerRef.current) return

      const observeTarget = containerRef.current
      const resizeObserver = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          setWidth(entry.contentRect.width)
        })
      })
      resizeObserver.observe(observeTarget)

      return () => {
        resizeObserver.unobserve(observeTarget)
      }
    }, [containerRef])

    return (
      <>
        <div ref={tooltipRef} className="data-point-tooltip" />
        {!renderingChart &&
          chartStatus &&
          chartStatus === DataStatus.Ready &&
          visibleLabels.length > 0 &&
          visibleLabels.map((thisLabel, index) => (
            <TrendsLabelCard
              ref={labelCardRef}
              key={index}
              width={width}
              isCustomLabel={thisLabel.action === CUSTOM_LABEL_ID}
              label={thisLabel}
              handlePin={handlePin}
              handleEdit={handleEdit}
              yPosition={index + 2}
            />
          ))}
        <svg
          ref={svgRef}
          id="svg-d3"
          className="svg-d3"
          width={width + margin.left + margin.right}
          height={height + margin.top + margin.bottom}
        />
      </>
    )
  }
)

export default TrendsChart
